<template>
    <section>
        <b-modal :title="title" v-model="open" ref="modal" size="lg">
            <div>
                <h2>Odpojení základny</h2>
                <small class="block text-sm text-muted">Upozornění při výpadku základny. (email)</small>
                <span>✅ Z bezpečnostních důvodů jsou emaily o odpojení základny zasílány vždy bez možnosti deaktivace</span>
            </div>
            <hr>
            <div>
                <h2>Připojení základny po výpadku</h2>
                <small class="block text-sm text-muted">Upozornění při opětovném připojení základny. (email)</small>
                <span>✅ Z bezpečnostních důvodů jsou emaily základny zasílány vždy bez možnosti deaktivace</span>
            </div>

            <template #footer>
                <b-btn @click="open=false">{{$t('message.ok')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    // import LastHour from './alarm/LastHour'
    // import Actual from './alarm/Actual'
    // import Sum from './alarm/Sum'
    // import Flow from './alarm/Flow'
    import mixins from '../../modules/mixins'
    import {ALARM_REQUEST} from '../../_store'
    import eventBus from '../../modules/eventBus'

    export default {
        name: 'Alarm',
        props: {
            unit: {
                type: String
            }
        },
        mixins: [mixins],
        data () {
            return {
                initialized: false,
                open: false,
                item: null,
                difference: false,
                'last-hour': [],
                actual: [],
                sum: [],
                flow: [],
                title: 'Alarmová hlášení',
                water: null,
                enable: true
            }
        },
        methods: {
            show (item, water) {
                this.water = water
                // const waterType = this.unit === 'watts' ? this.$t('message.electricity') : this.getWaterTypeText(water)
                this.initialized = false
                this.item = item
                this.open = true
                this.title = this.$t('message.alarm_reports') // + ' - ' + item.path + ' - ' + waterType
                this.$store.dispatch(ALARM_REQUEST, {
                    entity: item.id,
                    type: item.type,
                    action: 'read',
                    water: this.water,
                    medium: this.unit === 'watts' ? 'power' : 'water'
                }).then(resp => {
                    const data = resp.data
                    for (let key of ['last-hour', 'actual', 'sum', 'flow']) {
                        this[key] = data[key]
                    }
                    const difference = data.difference
                    this.difference = difference && typeof difference === 'object'
                        ? !!difference.enabled
                        : !!difference
                    this.$nextTick(() => {
                        this.item.alarms = this.hasAlarms()
                        // this.addEvent('last-hour')
                        // this.addEvent('actual')
                        // this.addEvent('sum')
                        // this.addEvent('flow')
                        this.initialized = true
                    })
                })
            },
            addEvent (eventType) {
                const defaultEvents = {
                    'last-hour': {
                        saved: false,
                        id: null,
                        type: 'last-hour',
                        comparision: 'gt',
                        liters: 0
                    },
                    'actual': {
                        saved: false,
                        id: null,
                        type: 'actual',
                        comparision: 'gt',
                        liters: 0
                    },
                    'sum': {
                        saved: false,
                        id: null,
                        type: 'sum',
                        comparision: 'gt',
                        liters: 0,
                        start: '8:00',
                        end: '18:00'
                    },
                    'flow': {
                        saved: false,
                        id: null,
                        type: 'flow',
                        liters: 0
                    }
                }
                this[eventType].push(defaultEvents[eventType])
            },
            getWaterTypeText (water) {
                switch (water) {
                case 'total':
                    return this.$t('message.cold_and_hot_water')
                case 'cold':
                    return this.$t('message.cold_water')
                case 'hot':
                    return this.$t('message.hot_water')
                }
            },
            eventChanged (action, event) {
                if (action === 'marked_to_delete') {
                    if (event.type !== 'difference') {
                        const index = this[event.type].indexOf(event)
                        this[event.type].splice(index, 1)
                    }
                    if (event.type === 'difference' || event.id != null) {
                        this.$store.dispatch(ALARM_REQUEST, {
                            entity: this.item.id,
                            type: this.item.type,
                            water: this.water,
                            data: event,
                            action: 'destroy',
                            medium: this.unit === 'watts' ? 'power' : 'water'
                        }).then(resp => {
                            this.item.alarms = this.hasAlarms()
                        })
                    }
                } else if (action === 'marked_to_save') {
                    if (event.id > 0) {
                        this.$store.dispatch(ALARM_REQUEST, {
                            entity: this.item.id,
                            type: this.item.type,
                            water: this.water,
                            data: event,
                            action: 'destroy',
                            medium: this.unit === 'watts' ? 'power' : 'water'
                        }).then(resp => {
                            this.item.alarms = this.hasAlarms()
                        })
                    }
                    const request = {
                        entity: this.item.id,
                        type: this.item.type,
                        water: this.water,
                        data: event,
                        action: 'create',
                        medium: this.unit === 'watts' ? 'power' : 'water'
                    }
                    this.$store.dispatch(ALARM_REQUEST, request)
                        .then(resp => {
                            event.id = resp.data.object.id
                            event.saved = true
                            this.item.alarms = this.hasAlarms()
                        })
                }
            },
            hasAlarms () {
                let sum = 0
                for (let key of ['last-hour', 'actual', 'sum', 'flow']) {
                    for (let i of this[key]) {
                        sum += i.saved ? 1 : 0
                    }
                }
                return this.difference || sum > 0
            }
        },
        watch: {
            difference (d) {
                if (!this.initialized) {
                    return
                }
                this.eventChanged(d ? 'marked_to_save' : 'marked_to_delete', {
                    'type': 'difference'
                })
            },
            open (open) {
                if (!open) {
                    eventBus.emit('reload-alerts', {})
                }
            }
        },
        created () {
            // this.addEvent('last-hour')
            // this.addEvent('actual')
            // this.addEvent('sum')
            // this.addEvent('flow')
        }
    }
</script>

<style scoped>
    .control-inline {
        display: inline-block;
        max-width: 75px;
    }
    .btn-add {
        margin-left: 8px;
    }
</style>
